module.exports = __webpack_public_path__ + "static/media/kefu.7da37959.png";